import { IUser, userRoleType } from '@core/models';
import { createRehydrateReducer } from '@core/utils/rehydrate-reducer';
import { on } from '@ngrx/store';

import { delUser, setUser } from '../actions/user.actions';

export const userInitialState: IUser = {
  role: [userRoleType.GUEST],
  name: '',
  email: '',
};

export const userReducer = createRehydrateReducer(
  { key: 'userReducer' },
  userInitialState,
  on(setUser, (state, { value }): IUser => ({ ...value })),

  on(delUser, (): IUser => ({ ...userInitialState }))
);
